import styled from "styled-components/macro";
import { media } from "../../../../utils";

export default styled.div({
  [media.lg()]: {
    paddingTop: "40px !important",
  },
});
